import { render } from "./OrgSetup.vue?vue&type=template&id=90eb2304&ts=true"
import script from "./OrgSetup.vue?vue&type=script&lang=ts"
export * from "./OrgSetup.vue?vue&type=script&lang=ts"

import "./OrgSetup.vue?vue&type=style&index=0&id=90eb2304&lang=scss"

import exportComponent from "/home/nathan/public_html/accident-plan/accident-plan-api-whitelabel/node_modules/vue-loader-v16/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render]])

export default __exports__